import PageTitle from '@components/PageTitle/PageTitle';
import ProtectedStepper from '@components/ProtectedStepper/ProtectedStepper';
import { useStepperActiveIndex } from '../../provider';
import { useGetSteps } from './hooks';

function ApplicationForm() {
  const activeIndex = useStepperActiveIndex();
  const steps = useGetSteps();
  return (
    <>
      <PageTitle />
      <ProtectedStepper activeIndex={activeIndex} loginStepIndex={0}>
        {steps}
      </ProtectedStepper>
    </>
  );
}

export default ApplicationForm;
